import styles from './LoginForm.module.scss';

export default function RefreshAuthView() {
  return <div className={styles.loginFormWrapper}>
    <p className={styles.refreshingMessage}>Refreshing Login...</p>
  </div>;
};
